import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import WelfareUnitsCalendar from '../drivers-welfare-units-calender.jsx';


if (document.getElementById('react-component-g4-logistics-portal-drivers-welfare-units-calendar')) {
    ReactDOM.render(
        <WelfareUnitsCalendar
            url="/api/v1/portal/drivers/get-drivers-welfare-units-calendar"
            isLoading={true}
        />,
        document.getElementById('react-component-g4-logistics-portal-drivers-welfare-units-calendar'));
}
